import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'dataTransactions',
        url: '/dataTransactions?beginDate&endDate',
        component: 'wtDataTransactionsState',
        params: {
            beginDate: '',
            endDate: ''
        },
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 1000,
            visible: false,
            icon: 'fa-history',
            displayName: 'Data transactions',
            editRoles: [],
            editButtonVisibility: () => false,
            ignoreHistory: false
        }
    }];

export default states;